console.log('app.js script')